export default __webpack_public_path__ + "static/media/on_3.24ffc0b7.mp3";